import { useCallback } from 'react';
import { RouterProvider } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ClientProvider } from 'client/context';
import { ApiError } from 'client/errors';
import { updateModal } from 'ducks/modals/slices';
import { updateSettings } from 'ducks/settings/slices';
import { clearUser } from 'ducks/user/slices';
import { router } from 'router';
import { useAppDispatch } from 'store/hooks';

import { ThemeProvider } from './framework/theme/ThemeProvider';

const { REACT_APP_VOLADEUM } = process.env;

export const App = () => {
  const dispatch = useAppDispatch();
  const errorCallback = useCallback(
    async (err: ApiError | unknown) => {
      dispatch(updateSettings({ loading: false }));
      if (err instanceof ApiError) {
        if (err?.status === 401) {
          dispatch(clearUser());
          return;
        }
        dispatch(
          updateModal({
            key: 'error',
            data: {
              is_open: true,
              name: err.name,
              message: err.message,
              error: err.error,
              status: err.status,
              code: err.code,
              payload: err.payload,
              response: err.response,
            },
          })
        );
      } else if (err instanceof Error) {
        dispatch(
          updateModal({
            key: 'error',
            data: { is_open: true, name: err.name, message: err.message, stack: err.stack },
          })
        );
      } else {
        dispatch(
          updateModal({
            key: 'error',
            data: { is_open: true, name: 'Error Unknown', message: '' },
          })
        );
      }
    },
    [dispatch]
  );
  return (
    <ThemeProvider>
      <ClientProvider host={{ VOLADEUM: REACT_APP_VOLADEUM }} errorCallback={errorCallback}>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
          <RouterProvider router={router} />
        </GoogleOAuthProvider>
      </ClientProvider>
    </ThemeProvider>
  );
};
